// extracted by mini-css-extract-plugin
export default {"context_menu":"styles_context_menu__iseW9","content":"styles_content__tSEDh"};